module.exports = __webpack_public_path__ + "public/img/rules.18b99219.png";